<template>
  <div class="pending-fault-container">
    <CardBox title="待处理故障" subtitle="Pending faults" :noBg="true">
      <div class="pending-fault-scroll">
        <vue-seamless-scroll
          :data="errorCountStatisticsListData"
          :class-option="{
            limitMoveNum: 1,
            step: 0.4,
            hoverStop: true,
            direction: 1,
            openTouch: false
          }"
          style="height: 100%"
        >
          <div class="pending-fault-cards">
            <div
              class="pending-fault-card"
              :class="{
                'pending-fault-card--has': item.undoErrorCount > 0,
                'pending-fault-card--empty': !item.undoErrorCount || item.undoErrorCount === 0
              }"
              v-for="(item, index) in errorCountStatisticsListData"
              :key="index"
            >
              <div class="pending-fault-card__name">
                {{ item.name ? item.name.replaceAll('阿米巴', '') : '' }}
              </div>
              <div class="pending-fault-card__count">{{ item.undoErrorCount }}</div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </CardBox>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { getTabberData } from '@utils'
import CardBox from './cardBox.vue'
import vueSeamlessScroll from 'vue-seamless-scroll/src'

export default {
  name: 'PendingFaultComponent',
  components: { CardBox, vueSeamlessScroll },
  setup() {
    const { dispatch } = useStore()

    const errorCountStatisticsListData = ref([])
    const getErrorCountStatisticsList = async () => {
      const { data } = await getTabberData(dispatch, 'fetchErrorCountStatisticsList')
      errorCountStatisticsListData.value = data || []
    }

    // 供父组件调用的定时刷新方法
    const refreshData = () => {
      getErrorCountStatisticsList()
    }

    onMounted(() => {
      getErrorCountStatisticsList()
    })

    return {
      errorCountStatisticsListData,
      refreshData
    }
  }
}
</script>

<style lang="scss" scoped>
.pending-fault-container {
  width: 100%;
  height: 140px;
  margin-top: 10px;
  overflow: hidden;
}

.pending-fault-scroll {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0 40px;
  box-sizing: border-box;
}

.pending-fault-cards {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 50px;
  padding: 0 4px;
}

.pending-fault-card {
  width: 148px;
  height: 72px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  margin-bottom: 16px;

  &--has {
    background-image: url('~@/assets/image/homeIndex/fault_card_has_pending.png');
  }

  &--empty {
    background-image: url('~@/assets/image/homeIndex/fault_card_no_pending.png');
  }

  &__name {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.85);
    font-family: 'SourceHanSansCN-Regular', sans-serif;
    margin-bottom: 4px;
    letter-spacing: 0.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90%;
    text-align: center;
  }

  &__count {
    font-size: 26px;
    font-weight: bold;
    color: #ffffff;
    font-family: 'OPPOSans-B', sans-serif;
    line-height: 1;
    text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
  }
}
</style>
